import menuData from './Menu.json';

const getMenuData = () => {
  return menuData;
};

export {getMenuData};
